module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "CT",
    attrs: {
      "id": "ch004"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch-004"
    }
  }, [_vm._v("4. The Kingdom of God")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush"
  }, [_c('b', [_vm._v("Literature:")]), _vm._v(" J. Weiss, "), _c('i', [_vm._v("Jesus’ Proclamation of the Kingdom of God")]), _vm._v(" (1892, Eng. ed. 1971); A. von Harnack, "), _c('i', [_vm._v("What Is Christianity?")]), _vm._v(" (1901); A. Schweitzer, "), _c('i', [_vm._v("The Quest of the Historical Jesus")]), _vm._v(" (1911); R. Bultmann, "), _c('i', [_vm._v("Jesus and the Word")]), _vm._v(" (1934); T. W. Manson, "), _c('i', [_vm._v("The Teaching of Jesus")]), _vm._v(" (1935); C. H. Dodd, "), _c('i', [_vm._v("The Parables of the Kingdom")]), _vm._v(" (1936); W. G. Kümmel, "), _c('i', [_vm._v("Promise and Fulfilment")]), _vm._v(" (1957); R. Schnackenburg, "), _c('i', [_vm._v("God’s Rule and Kingdom")]), _vm._v(" (1963); H. N. Ridderbos, "), _c('i', [_vm._v("The Coming of the Kingdom")]), _vm._v(" (1963); G. E. Ladd, "), _c('i', [_vm._v("Jesus and the Kingdom")]), _vm._v(" (1964); B. E. Gärtner, “The Person of Jesus and the Kingdom of God,” "), _c('i', [_vm._v("Th Today")]), _vm._v(" 27 (1970), 32-43; R. Hiers, "), _c('i', [_vm._v("The Kingdom of God in the Synoptic Tradition")]), _vm._v(" (1970); J. Jeremias, "), _c('i', [_vm._v("NT Theology")]), _vm._v(" (1971); W. G. Kümmel, “Eschatological Expectation in the Proclamation of Jesus,” in "), _c('i', [_vm._v("The Future of Our Religious Past")]), _vm._v(", ed. J. Robinson (1972); B. Chilton, “Regnum Dei Deus Est,” "), _c('i', [_vm._v("SJTh")]), _vm._v(" 31 (1978), 261-70; C. L. Mitton, "), _c('i', [_vm._v("Your Kingdom Come")]), _vm._v(" (1978); B. Chilton, "), _c('i', [_vm._v("God in Strength: Jesus’ Announcement of the Kingdom")]), _vm._v(" (1979); R. Recker, “The Redemptive Focus of the Kingdom of God,” "), _c('i', [_vm._v("CTJ")]), _vm._v(" 14 (1979), 154-86; A. J. Hultgren (ed.), “The Kingdom of God,” "), _c('i', [_vm._v("WW")]), _vm._v(" (1982); D. C. Allison, "), _c('i', [_vm._v("The End of the Ages Has Come")]), _vm._v(" (1985); A. J. Borg, “A Temperate Case for a Non-Eschatological Jesus,” "), _c('i', [_vm._v("Forum")]), _vm._v(" 2 (1986), 81-102; G. R. Beasley-Murray, "), _c('i', [_vm._v("Jesus and the Kingdom of God")]), _vm._v(" (1986); C. C. Caragounis, “Kingdom of God, Son of Man and Jesus’ Self-Understanding,” "), _c('i', [_vm._v("TB")]), _vm._v(" 40 (1989), 3-23; O. Betz, “Jesus’ Gospel of the Kingdom,” in "), _c('i', [_vm._v("The Gospel in the Gospels")]), _vm._v(", ed. P. Stuhlmacher (1991), 53-74.")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Modern scholarship is quite unanimous in the opinion that the Kingdom of God was the central message of Jesus. Mark introduces Jesus’ mission with the words, “Now after John was arrested, Jesus came into Galilee, preaching the gospel of God, and saying, ‘The time is fulfilled, and the kingdom of God is at hand; repent and believe in the gospel’ ” (Mk. 1:14-15). Matthew summarizes his ministry with the words, “He went about all Galilee, teaching in their synagogues and preaching the gospel of the kingdom” (Mt. 4:23). Luke’s introductory scene does not mention the Kingdom of God but instead quotes a prophecy from Isaiah about the coming of the Kingdom and then relates Jesus’ affirmation, “Today this scripture has been fulfilled in your hearing” (Lk. 4:21).")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_vm._v("Interpretations of the Kingdom of God")])]), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_c('p', {
    staticClass: "Bodyflush2"
  }, [_c('b', [_vm._v("Literature:")]), _vm._v(" For surveys of the history of interpretation see G. E. Ladd, "), _c('i', [_vm._v("Crucial Questions about the Kingdom of God")]), _vm._v(" (1952), 21-60; H. N. Ridderbos, "), _c('i', [_vm._v("The Coming of the Kingdom")]), _vm._v(" (1963), xi-xxxiv; N. Perrin, "), _c('i', [_vm._v("The Kingdom of God in the Teaching of Jesus")]), _vm._v(" (1963); G. Lundström, "), _c('i', [_vm._v("The Kingdom of God in the Teaching of Jesus")]), _vm._v(" (1963); G. E. Ladd, "), _c('i', [_vm._v("Jesus and the Kingdom")]), _vm._v(" (1964), 3-38; B. Chilton (ed.), "), _c('i', [_vm._v("The Kingdom of God in the Teaching of Jesus")]), _vm._v(" (1984); W. Willis (ed.), "), _c('i', [_vm._v("The Kingdom of God in 20th Century Interpretation")]), _vm._v(" (1987).")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Interpretations of the Kingdom of God have taken several distinct forms, with almost infinite variety in detail. From Augustine to the reformers, the prevalent view was that the Kingdom was in some sense or other to be identified with the church. This view is seldom defended now, even among Catholic scholars. The church is the people of the Kingdom but cannot be identified with the Kingdom.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_vm._v("The old liberal view is represented by Harnack’s "), _c('i', [_vm._v("What Is Christianity?")]), _vm._v(" and understands the Kingdom of God as the pure prophetic religion taught by Jesus: the Fatherhood of God, the “brotherhood of man,” the infinite value of the individual soul, and the ethic of love. The obvious apocalyptic element in Jesus’ teaching was only the time-conditioned husk that contained the kernel of his real religious message. Noneschatological interpretations of the Kingdom of God have been legion. Many scholars have understood the Kingdom primarily in terms of personal religious experience — the reign of God in the individual soul."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1",
      "id": "fn1"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In 1892, Johannes Weiss published a slim book entitled “The Preaching of Jesus about the Kingdom of God,”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn2",
      "id": "fn2"
    }
  }, [_vm._v("2")])]), _vm._v(" in which he argued that Jesus’ view of the Kingdom was like that of the Jewish apocalypses: altogether future and eschatological. The victory of the Kingdom of God over Satan had already been won in heaven; therefore Jesus proclaims its coming on earth. The Kingdom will be altogether God’s supernatural act, and when it comes, Jesus will be the heavenly Son of Man.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Albert Schweitzer picked up this idea and interpreted the entire career of Jesus from the point of view of the eschatological understanding of the Kingdom, which Jesus expected to come in the immediate future — an interpretation that he called "), _c('i', [_vm._v("konsequente Eschatologie")]), _vm._v(" (Consistent Eschatology). Jesus’ ethical teaching was designed only for the brief interval before the end comes (interim ethics), not for the ordinary life of people in society. The Kingdom did not come, and Jesus died in despair and disillusionment. Such to Schweitzer was “the historical Jesus” — a deluded first-century apocalyptist.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Since Weiss and Schweitzer, most scholars have recognized that the apocalyptic element belongs to the kernel and not the husk of Jesus’ teachings, but few contemporary scholars view the Kingdom as exclusively eschatological. "), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("Richard Hiers is an exception. Rudolf Bultmann has accepted the imminent approach of the eschatological Kingdom as the correct historical interpretation of Jesus’ message, but the true meaning must be understood in existential terms: the nearness and the demand of God.")])]), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("In Great Britain, the most influential interpretation has been the “Realized Eschatology” of C. H. Dodd. Dodd does not simply discard the apocalyptic language as did Harnack; he understands it as a series of symbols standing for realities that the human mind cannot directly apprehend. The Kingdom of God, which is described in apocalyptic language, is in reality the transcendent order beyond time and space that has broken into history in the mission of Jesus. In him, the “wholly other” has entered into history. This transcendent “wholly other” in Dodd’s thought is more platonic than biblical. In this event, all that the prophets had hoped for has been realized in history. This is what Dodd means by “realized eschatology.” Dodd has been criticized for minimizing the futuristic aspect of the Kingdom,"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn3",
      "id": "fn3"
    }
  }, [_vm._v("3")]), _vm._v(" and in his latest publication he admits that the Kingdom yet awaits consummation “beyond history.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn4",
      "id": "fn4"
    }
  }, [_vm._v("4")])]), _vm._v(" However, many scholars have followed Dodd in his view that the most distinctive thing about Jesus’ teaching was the presence of the Kingdom.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("If a majority of scholars have approached a consensus, it is that the Kingdom is in some real sense both present and future. W. G. Kümmel understands that the primary meaning of the Kingdom is the eschaton — the new age analogous to Jewish apocalyptic. Jesus proclaimed that the new age was near. But Kümmel holds that it is also present, but only in the person of Jesus, not in his disciples. The future eschatological Kingdom has already begun its activity in Jesus’ mission. It is not altogether clear how in Kümmel’s view the Kingdom can be both the future eschaton and a present activity in Jesus. Other scholars have solved this problem by holding that the Kingdom was altogether future, but it was so very near that its power could already be felt — as the dawn precedes sunrise;"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn5",
      "id": "fn5"
    }
  }, [_vm._v("5")])]), _vm._v(" or else the signs of the Kingdom were present but not the Kingdom itself."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn6",
      "id": "fn6"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Jeremias defends a distinctive position. While commending C. H. Dodd for achieving a real breakthrough in the history of interpretation by his emphasis on the present irruption of the Kingdom, he criticizes him for minimizing the eschatological aspect. In place of Dodd’s “realized eschatology” Jeremias suggests “eschatology in process of realization.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn7",
      "id": "fn7"
    }
  }, [_vm._v("7")])]), _vm._v(" Jeremias understands Jesus’ entire ministry to be an event in which the Kingdom is realized. He even sees John the Baptist as standing in the time of fulfillment, because the Spirit has come "), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_vm._v("upon him and the time of salvation has begun."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn8",
      "id": "fn8"
    }
  }, [_vm._v("8")]), _vm._v(" With Jesus’ message of the Kingdom of God and his miracles of exorcism, the Kingdom has broken into history. However, Jesus looked forward to the imminent eschatological consummation of the Kingdom that would involve his own resurrection and parousia. Jeremias follows Dodd’s suggestion that Jesus regarded his resurrection, parousia, and the consummation of the Kingdom as a single event in which the triumph of God would be manifested."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn9",
      "id": "fn9"
    }
  }, [_vm._v("9")])]), _vm._v(" In the resurrection appearances, the disciples experienced Jesus’ parousia."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn10",
      "id": "fn10"
    }
  }, [_vm._v("10")])]), _vm._v(" Only after Easter did the early church separate the parousia from the resurrection."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn11",
      "id": "fn11"
    }
  }, [_vm._v("11")])]), _vm._v(" It is difficult to see any material difference between Jeremias’s view and the view of Dodd that he criticizes.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In certain evangelical circles in America and Great Britain, a rather novel view of the Kingdom has had wide influence. Starting from the premise that all Old Testament prophecies to Israel must be fulfilled "), _c('i', [_vm._v("literally")]), _vm._v(", dispensationalists have distinguished sharply between the Kingdom of God and the Kingdom of Heaven. The latter is the rule of heaven (God) on earth and has primary reference to the earthly theocratic Kingdom promised Old Testament Israel. Matthew’s Gospel alone gives us the Jewish aspect of the Kingdom. When Jesus announced that the Kingdom of Heaven was at hand, he had reference to the earthly theocratic Kingdom promised Israel. However, Israel rejected the offer of the Kingdom, and instead of establishing the Kingdom for Israel Jesus introduced a new message, offering rest and service for all who would believe, and initiating the formation of a new family of faith that cuts across all racial lines. The mystery of the Kingdom of Heaven in Matthew 13 is the sphere of Christian profession — Christendom — which is the form God’s rule over the earth takes between the two advents of Christ. Leaven (Mt. 13:33) always represents evil; in the Kingdom of Heaven — the professing church — true doctrine is to be corrupted by false doctrine. The Sermon on the Mount is the law of the Kingdom of Heaven — the Mosaic Law of the Old Testament theocratic Kingdom, interpreted by Christ, destined to be the governing code of the earthly Kingdom. The Kingdom of Heaven, rejected by Israel, will be realized at the return of Christ when Israel will be converted and the Old Testament promises of the restoration of David’s Kingdom literally fulfilled. The basic tenet of this theology is that there are two peoples of God — Israel and the church — with two destinies under two divine programs."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn12",
      "id": "fn12"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_vm._v("Within a year (1963-64), three books appeared independently of each other that interpreted the Kingdom in basically the same way in terms of the unfolding of redemptive history. The Kingdom is God’s kingly rule. It has two moments: a fulfillment of the Old Testament promises in the historical mission of Jesus and a consummation at the end of the age, inaugurating the Age to Come."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn13",
      "id": "fn13"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("The Kingdom of God in Judaism")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush2"
  }, [_c('b', [_vm._v("Literature:")]), _vm._v(" J. Bright, "), _c('i', [_vm._v("The Kingdom of God")]), _vm._v(" (1953); S. Mowinckel, "), _c('i', [_vm._v("He That Cometh")]), _vm._v(" (1956); G. E. Ladd, "), _c('i', [_vm._v("Jesus and the Kingdom")]), _vm._v(" (1964), 41-97; P. D. Hanson, "), _c('i', [_vm._v("The Dawn of Apocalyptic")]), _vm._v(" (1979).")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("While the idiom “the Kingdom of God” does not occur in the Old Testament, the idea is found throughout the prophets. There is a twofold emphasis on God’s kingship. He is frequently spoken of as the King, both of Israel (Exod. 15:18; Num. 23:21; Deut. 33:5; Isa. 43:15) and of all the earth (2 Kings 19:15; Isa. 6:5; Jer. 46:18; Ps. 29:10; 99:1-4). Although God is now King, other references speak of a day when he shall become King and shall rule over his people (Isa. 24:23; 33:22; 52:7; Zeph. 3:15; Zech. 14:9ff.)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn14",
      "id": "fn14"
    }
  }, [_vm._v("14")])]), _vm._v(" This leads to the conclusion that while God is the King, he must also become King, i.e., he must manifest his kingship in the world of human beings and nations.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The form of the future Kingdom is expressed differently by different prophets. Many scholars see two distinctly different kinds of hope in the Old Testament and Judaism. The truly Hebraic, prophetic hope expects the Kingdom to arise out of history and to be ruled by a descendant of David in an earthly setting (Isa. 9, 11). When this hope faded after the return from exile, the Jews lost hope of a Kingdom in history. In its place, they looked for an apocalyptic inbreaking of God in the person of a heavenly Son of Man with a completely transcendental Kingdom “beyond history” (Dan. 7). The present author has argued elsewhere that while there is considerable diversity in the description of the Kingdom in the Old Testament, it always involves an inbreaking of God into history when God’s redemptive purpose is fully realized. The Kingdom is always an earthly hope, although an earth redeemed from the curse of evil. However, the Old Testament hope is always ethical and not speculative. It lets the light of the future shine on the present, that Israel may be confronted by history in the here and now. For this reason, there is a coalescing of the near and the distant future. God will act in the near future to save or judge Israel, but he will also act in the indeterminate future to bring about the fulfillment of the eschatological hope. The prophets do not sharply distinguish between the near and the distant future, for both will see the act of God for his people.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_vm._v("Apocalyptic Judaism also had diverse hopes. Some writers emphasize the earthly, historical aspect of the Kingdom (En. 1–36; Ps. Sol. 17–18), while others emphasize the more transcendental aspects (En. 37–71). However, the emphasis is always eschatological. In fact, Jewish apocalyptic lost the sense of God’s acting in the historical present. At this point, apocalypticism had become pessimistic — not with reference to the final act of God to establish his Kingdom, but with reference to God’s acting in present history to save and bless his people. Jewish apocalyptic despaired of history, feeling that it was given over to evil powers. God’s people could only expect suffering and affliction in this age until God would act to establish his Kingdom in the Age to Come."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn15",
      "id": "fn15"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Qumran community shared a similar hope for the Kingdom. In the eschatological consummation, they expected the angels to come down and join battle with them — “the sons of light” — against their enemies — “the sons of darkness” — and to give victory to the Qumranians over all other peoples, whether worldly Jews or Gentiles."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn16",
      "id": "fn16"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The rabbinic literature developed a similar eschatology, but made somewhat more use of the term “the kingdom of the heavens.” The Kingdom of God was the reign of God — the exercise of his sovereignty."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn17",
      "id": "fn17"
    }
  }, [_vm._v("17")])]), _vm._v(" Throughout the course of human history, God exercised his sovereignty through his Law. Those who submit to the Law thereby submit themselves to the reign of God. A Gentile turning to Judaism and adopting the Law thereby “takes upon himself the sovereignty (kingdom) of God.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn18",
      "id": "fn18"
    }
  }, [_vm._v("18")])]), _vm._v(" Obedience to the Law is thus equivalent to the experience of God’s Kingdom or rule. It follows that God’s Kingdom on earth is limited to Israel. Furthermore, it does not "), _c('i', [_vm._v("come")]), _vm._v(" to people; it is there, embodied in the Law, available to all who will submit to it.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("At the end of the age, however, God will manifest his sovereignty in all the world. A very ancient prayer concludes with the wish, “and may He [God] set up His sovereignty in your lifetime, and in your days, and in the lifetime of the whole house of Israel, [yea] speedily, and in a time that is near.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn19",
      "id": "fn19"
    }
  }, [_vm._v("19")])]), _vm._v(" The Assumption of Moses reads, “And then His Kingdom shall appear throughout all His creation” (Ass. Mos. 10:1). In this age, God’s rule is limited to those who accept the Law; at the end of the age, it will appear to subjugate all that "), _c('i', [_vm._v("resists")]), _vm._v(" the will of God. The experience of God’s sovereignty in the present is dependent upon the free decision of men and women;"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn20",
      "id": "fn20"
    }
  }, [_vm._v("20")])]), _vm._v(" but when it "), _c('i', [_vm._v("appears")]), _vm._v(" at the end of the age, “the Heavenly One shall arise from His royal throne” (Ass. "), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("Mos. 10:3) to punish the wicked and gather righteous Israel into a redeemed order of blessing."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn21",
      "id": "fn21"
    }
  }, [_vm._v("21")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Another movement in Judaism was quite certainly concerned with establishing the Kingdom of God: the Zealots. In the early decades of the first century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.D.")]), _vm._v(", insurrection broke out again and again, promoted by the Zealots, against Rome. The New Testament speaks of insurrection under Judas and Theudas (Acts 5:36, 37), and another revolt under an unnamed Egyptian (Acts 21:38). Josephus speaks of other revolutionary movements not mentioned in the New Testament. He does not label these revolutionaries, but in the last rebellion of "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.D")]), _vm._v(". 132 the leader, Bar Kokhba, was styled by the Akiba, most famous rabbi of the time, as the Messiah."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn22",
      "id": "fn22"
    }
  }, [_vm._v("22")])]), _vm._v(" The Zealots were Jewish radicals who were not content to wait quietly for God to bring his Kingdom but wished to hasten its coming with the sword."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn23",
      "id": "fn23"
    }
  }, [_vm._v("23")])]), _vm._v(" It is possible, and even probable, that the whole series of revolts against Rome were messianic, i.e., that they were not conducted solely for political or nationalistic goals, but were religiously motivated to hasten the coming of God’s Kingdom."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn24",
      "id": "fn24"
    }
  }, [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In any case, throughout all Judaism, the coming of God’s Kingdom was expected to be an act of God — perhaps using the agency of human beings — to defeat the wicked enemies of Israel and to gather Israel together, victorious over its enemies, in its promised land, under the rule of God alone.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("The Meaning of basileia tou theou (“Kingdom of God”)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush2"
  }, [_vm._v("Scholars are not agreed as to the basic meaning of "), _c('i', [_vm._v("basileia")]), _vm._v(" (Heb. "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("malkûṯ")])]), _vm._v("). Many have defended the view that the "), _c('i', [_vm._v("basileia")]), _vm._v(" is the “eschaton” — the final eschatological order."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn25",
      "id": "fn25"
    }
  }, [_vm._v("25")])]), _vm._v(" If this is taken as the point of departure, it is difficult to see how the eschaton can be both future and present; it must be exclusively future. However, the Hebrew word has the abstract dynamic or idea of reign, rule, or dominion. “They shall speak of the glory of thy kingdom, and tell of thy power. . . . Thy kingdom is an everlasting kingdom, and thy dominion endures throughout all generations” (Ps. 145:11, 13). “The L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" has established his throne in the heavens, and his kingdom rules over all” (Ps. 103:19)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn26",
      "id": "fn26"
    }
  }, [_vm._v("26")])]), _vm._v(" In late Judaism, the Kingdom of God means God’s rule or sovereignty."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn27",
      "id": "fn27"
    }
  }, [_vm._v("27")])]), _vm._v(" This is also the best point of departure for "), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("understanding the Gospels. Several times the RSV renders "), _c('i', [_vm._v("basileia")]), _vm._v(" by the English word “kingship,” or “kingly power” (Lk. 19:12; 23:4-2; Jn. 18:36; Rev. 17:12). The meaning “reign” or “rule” is obvious in other passages."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn28",
      "id": "fn28"
    }
  }, [_vm._v("28")]), _vm._v(" The coming of the Kingdom for which we pray in the Lord’s Prayer means that God’s will be done on earth, i.e., that his rule be perfectly realized (Mt. 6:10). The “kingdom” that Jesus appointed for his disciples (Lk. 22:29) is “royal rule.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn29",
      "id": "fn29"
    }
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This is important for the interpretation of Jesus’ message, for one of the major problems is that of how the Kingdom of God can be both future and present. If the Kingdom is primarily the eschaton — the eschatological era of salvation — it is difficult to see how this future realm can also be present. However, we have seen that both in the Old Testament and in rabbinic Judaism, God’s Kingdom — his reign — can have more than one meaning. God is now the King, but he must also "), _c('i', [_vm._v("become")]), _vm._v(" King. This is the key to the solution of the problem in the Gospels.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("The Kingdom of Heaven(s)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush2"
  }, [_vm._v("The phrase “the kingdom of the heavens” occurs only in Matthew,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn30",
      "id": "fn30"
    }
  }, [_vm._v("30")])]), _vm._v(" where it is used thirty-two times. Several times in Matthew,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn31",
      "id": "fn31"
    }
  }, [_vm._v("31")])]), _vm._v(" and everywhere in the rest of the New Testament, the phrase “kingdom of God” is used. “The kingdom of the heavens” is a Semitic idiom, where heavens is a substitute for the divine name (see Lk. 15:18). Since the gospel tradition shows that Jesus did not consistently avoid the word “God,” it is possible that “the kingdom of the heavens” is native to the Jewish-Christian milieu, which preserved the gospel tradition in Matthew rather than reflecting the actual usage of Jesus."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn32",
      "id": "fn32"
    }
  }, [_vm._v("32")])]), _vm._v(" Possibly he used both phrases, and the Gospels that were addressed to a Gentile audience omitted the Semitic idiom, which would be meaningless to their ears.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("As a matter of fact, both “the kingdom of God” and “the kingdom of the heavens” are seldom used in Jewish literature "), _c('i', [_vm._v("before")]), _vm._v(" the days of Jesus."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn33",
      "id": "fn33"
    }
  }, [_vm._v("33")])]), _vm._v(" Jeremias stresses this fact, that in Jesus’ teaching a large number of new phrases about the "), _c('i', [_vm._v("basileia")]), _vm._v(" appear that have no parallels in the literature of the world of Jesus — a fact to which sufficient attention has not yet been paid."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn34",
      "id": "fn34"
    }
  }, [_vm._v("34")])])]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("The Eschatological Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush2"
  }, [_vm._v("We have seen above that the basic structure of Jesus’ thought is the eschatological dualism of the two ages. It is the coming of God’s Kingdom (Mt. 6:10) or its "), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_vm._v("appearing (Lk. 19:11) that will bring this age to its end and inaugurate the Age to Come. It is important to note, however, that "), _c('i', [_vm._v("basileia")]), _vm._v(" can designate both the manifestation or coming of God’s kingly rule and the eschatological realm in which God’s rule is enjoyed. In this sense, inheriting eternal life and entrance into the Kingdom of God are synonymous with entering into the Age to Come. When the rich young ruler asked Jesus what he must do to inherit eternal life, he was thinking of the eschatological life of Daniel 12:2. Jesus replied that it is hard for a rich person to enter the Kingdom of God."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn35",
      "id": "fn35"
    }
  }, [_vm._v("35")]), _vm._v(" Then, turning to his disciples, he assured them that because they had left house and family to follow him, they would receive eternal life in the Age to Come (Mk. 10:17-31).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The coming of God’s Kingdom will mean the final and total destruction of the devil and his angels (Mt. 25:41), the formation of a redeemed society unmixed with evil (Mt. 13:36-43), perfected fellowship with God at the messianic feast (Lk. 13:28-29). In this sense the Kingdom of God is a synonym for the Age to Come.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("One of the most distinctive facts that set Jesus’ teaching apart from Judaism was the universalizing of the concept. Both in the Old Testament and in Judaism, the Kingdom was always pictured in terms of Israel. In the Old Testament, sometimes the Gentiles would be conquered by Israel (Amos 9:12; Mic. 5:9; Isa. 45:14-16; 60:12, 14), sometimes they are seen as converted (Zeph. 3:9, 20; 2:2-4; Zech. 8:20-23). But the Kingdom is always Israel’s. Late Judaism had become quite particularistic, and the establishing of God’s Kingdom meant the sovereignty of Israel over her political and national enemies: “Then thou, O Israel, shalt be happy, and thou shalt mount upon the necks and wings of the eagle . . . and thou shalt look from on high and shalt see thy enemies in Gehenna, and thou shalt recognize them and rejoice” (Ass. Mos. 10:8-10).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("We have seen that John the Baptist rejected this Jewish particularism and looked upon the most religious of the Jews as being in need of repentance to enter the coming Kingdom. Jesus made response to his own person and message the determining factor for entering the eschatological Kingdom. In fact, Jesus affirmed that Israel, the natural “sons of the kingdom,” will be rejected from the Kingdom and their place taken by others (Mt. 8:12). The true “sons of the kingdom” are those who respond to Jesus and accept his word (Mt. 13:38). One must receive the present proclamation of the Kingdom of God with a childlike attitude of complete dependence to enter into the eschatological Kingdom (Mk. 10:15).")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("The Present Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush2"
  }, [_vm._v("The expectation of the coming of the eschatological Kingdom in Jesus’ teaching was nothing new. It goes back to the prophets and was developed in different "), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_vm._v("ways in Judaism. C. H. Dodd is right in affirming that the most characteristic and distinctive of the gospel sayings are those which speak of a present coming of the Kingdom. Such sayings have no parallel in Jewish teaching or prayers of the period."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn36",
      "id": "fn36"
    }
  }, [_vm._v("36")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Jesus saw his ministry as a fulfillment of the Old Testament promise in history, short of the apocalyptic consummation."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn37",
      "id": "fn37"
    }
  }, [_vm._v("37")])]), _vm._v(" This is particularly clear in two passages. In the synagogue of Nazareth, Jesus read the messianic prophecy from Isaiah 61:1-2 about the coming of an anointed one to proclaim the acceptable year of the Lord; and he then solemnly asserted, “Today this scripture has been fulfilled in your hearing” (Lk. 4:21). When John the Baptist, in doubt, sent emissaries to ask Jesus if he really was the Coming One, Jesus replied by citing the messianic prophecy in Isaiah 35:5-6 and told them to report to John that the prophecy was indeed being fulfilled (Mt. 11:2-6). Throughout the Synoptic Gospels, Jesus’ mission is repeatedly understood as the fulfillment of the Old Testament promises.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The sayings about the Kingdom of God as a present reality must be interpreted against this background. The strongest statement is Matthew 12:28: “But if it is by the Spirit of God"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn38",
      "id": "fn38"
    }
  }, [_vm._v("38")])]), _vm._v(" that I cast out demons, then the Kingdom of God has come upon you.” One of Jesus’ most characteristic miracles was the exorcism of demons. Jesus amazed people because he spoke words of command and people were at once delivered from satanic bondage (Mk. 1:28). When accused of himself exercising satanic power, he replied that he cast out demons by the power of God, and this was proof that the Kingdom of God had come upon them.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A vigorous debate has been waged over the precise meaning of the Greek word "), _c('i', [_vm._v("ephthasen")]), _vm._v(", “has come,” in Mt. 12:28. Many have interpreted the word to designate proximity, not actual presence. But other uses make it clear that the verb connotes actual presence, not merely proximity."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn39",
      "id": "fn39"
    }
  }, [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("What was present was not the eschaton, but the kingly power of God, attacking the dominion of Satan and delivering people from the power of evil. “Or how can one enter a strong man’s house and plunder his goods, unless he first binds the strong man? Then indeed he may plunder his goods” (Mt. 12:29). In these words, Jesus declares that he has invaded the kingdom of Satan and has “bound” the strong man.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In these two verses is embodied the essential theology of the Kingdom of God. Instead of waiting until the end of the age to reveal his kingly power and destroy satanic evil, Jesus declares that God has acted in his kingly power to "), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_vm._v("curb the power of Satan. In other words, God’s Kingdom in Jesus’ teaching has a twofold manifestation: at the end of the age to destroy Satan, and in Jesus’ mission to bind Satan. Before Satan’s final destruction, people may be delivered from his power."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn40",
      "id": "fn40"
    }
  }, [_vm._v("40")]), _vm._v(" “Binding” is of course a metaphor and designates in some real sense a victory over Satan so that his power is curbed. Sometimes the metaphorical nature of the idiom is not recognized, and it is thought that the saying must mean that Satan is rendered completely powerless."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn41",
      "id": "fn41"
    }
  }, [_vm._v("41")])]), _vm._v(" However, Satan continues to be active: he snatches away the word of the Kingdom when it does not find real acceptance among men and women (Mt. 13:19); he was able to speak through Peter (Mk. 8:33); he entered into Judas (Lk. 22:3); and he wanted also to take possession of Peter (Lk. 22:31). Cullmann interprets the binding of Satan by his quaint idiom that he is bound, but with a long rope."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn42",
      "id": "fn42"
    }
  }, [_vm._v("42")])]), _vm._v(" Satan is not powerless, but his power has been broken. Cullmann again illustrates this by resorting to a military idiom. The decisive battle in a war may be won and the tide of battle turn before the gaining of final victory."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn43",
      "id": "fn43"
    }
  }, [_vm._v("43")])]), _vm._v(" The whole mission of Jesus, including his words, deeds, death, and resurrection, constituted an initial defeat of satanic power that makes the final outcome and triumph of God’s Kingdom certain. “Every occasion in which Jesus drives out an evil spirit is an anticipation of the hour in which Satan will be visibly robbed of his power. The victories over his instruments are a foretaste of the eschaton.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn44",
      "id": "fn44"
    }
  }, [_vm._v("44")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Scholars have debated "), _c('i', [_vm._v("when")]), _vm._v(" the binding of Satan occurred. Many refer it to the specific event of Jesus’ victory over Satan in the wilderness;"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn45",
      "id": "fn45"
    }
  }, [_vm._v("45")])]), _vm._v(" but “the simplest explanation is that the exorcisms themselves are regarded as a victorious combat with the devil and his kingdom. Whenever a demon is cast out from a body it signifies that Satan has been defeated and spoiled of his goods.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn46",
      "id": "fn46"
    }
  }, [_vm._v("46")])]), _vm._v(" “In each act of exorcism Jesus saw a defeat of Satan.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn47",
      "id": "fn47"
    }
  }, [_vm._v("47")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The same victory over Satan is seen in the power Jesus gave to his disciples when he commissioned them to travel throughout Galilee preaching the Kingdom of God (Lk. 10:9). When the missioners returned, they reported with joy that even the demons were subject to them in Jesus’ name. Then Jesus said, “I saw Satan fall like lightning from heaven” (Lk. 10:18). There is no need to postulate a vision in which Jesus saw Satan cast out of heaven."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn48",
      "id": "fn48"
    }
  }, [_vm._v("48")])]), _vm._v(" The context suggests that Jesus saw in the successful mission of the seventy an evidence of the defeat of Satan. Here again is metaphorical language that employs a different "), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_vm._v("idiom to affirm that in the mission of Jesus, a decisive victory has been won. Satan has been bound; he has fallen from his place of power; but his final destruction awaits the end of the age."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn49",
      "id": "fn49"
    }
  }, [_vm._v("49")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Here is an insoluble mystery in New Testament theology, which is found not only in the Synoptics but elsewhere as well. The enemies of God’s Kingdom are now seen not as hostile evil nations as in the Old Testament but spiritual powers of evil. The victory of God’s Kingdom is a victory in the spiritual world: God’s triumph over Satan. Paul affirms the same truth in 1 Corinthians 15:25: “He must reign until he has put all his enemies under his feet.” The interesting question is: Why does the New Testament not picture this as a battle exclusively in the spiritual world? Why can the victory over evil be won only on the plane of history? No explanation is given, but the answer lies in the fact that the fate of human beings is involved in this struggle. In some way beyond human comprehension, Jesus wrestled with the powers of evil, won a victory over them, that in the end of the age these powers may be finally and forever broken.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This sets the Christian gospel apart from Judaism. Contemporary apocalyptic conceived of the age as under the power of evil while God had retreated from the scene of human history. In the Dream Visions of Enoch, God is pictured as withdrawing his personal leadership from Israel after the captivity. He surrendered his people to wild beasts to be torn and devoured. God “remained unmoved, though He saw it, and rejoiced that they were devoured and swallowed and robbed, and left them to be devoured in the hand of all the beasts” (En. 89:58). In the day of judgment Israel would be delivered and her tormentors punished; but in history God was aloof and unmoved by the sufferings of his people.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Jesus’ message is that in his own person and mission God has invaded human history and has triumphed over evil, even though the final deliverance will occur only at the end of the age.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The presence of the Kingdom is asserted in Luke 17:20. When the Pharisees asked "), _c('i', [_vm._v("when")]), _vm._v(" the apocalyptic Kingdom was coming, Jesus answered them, rather enigmatically, that the Kingdom was already in their midst, but in an unexpected form. It was not accompanied by the signs and outward display the Pharisees expected and without which they would not be satisfied. The phrase "), _c('i', [_vm._v("entos hymōn")]), _vm._v(" can mean either “within you,” i.e., in your hearts, or “in your midst.” While Mark 10:15 makes it clear that the Kingdom is to be received in the inner person,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn50",
      "id": "fn50"
    }
  }, [_vm._v("50")])]), _vm._v(" it is unlikely that Jesus would have said to the Pharisees, “the Kingdom of God is within you.” The translation “in your midst,” in Jesus’ person, best fits the total context of his teaching."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn51",
      "id": "fn51"
    }
  }, [_vm._v("51")])])]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_vm._v("The New Eschatological Structure")])]), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_c('p', {
    staticClass: "Bodyflush2"
  }, [_vm._v("Jesus’ teaching about the Kingdom of God radically modifies the redemptive time line. The Old Testament and Judaism looked forward to a single day — the Day of the Lord — when God would act to establish his reign on the earth. It can be diagrammed by a straight line:")]), _vm._v(" "), _c('div', {
    staticClass: "group_image"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/image001.jpg"
    }
  })])])]), _c('p', {
    staticClass: "Body1"
  }, [_c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_vm._v("Cullmann argues that Christ has modified the time line by giving it a new center. It retained the same basic structure as in Judaism, but the center shifted."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn52",
      "id": "fn52"
    }
  }, [_vm._v("52")]), _vm._v(" Cullmann has been justly criticized for overemphasizing the midpoint of history at the expense of the end."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn53",
      "id": "fn53"
    }
  }, [_vm._v("53")])])]), _vm._v(" "), _c('div', {
    staticClass: "group_image"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/image002.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_vm._v("Long ago Geerhardus Vos suggested a similar but perhaps better time line."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn54",
      "id": "fn54"
    }
  }, [_vm._v("54")])])]), _vm._v(" "), _c('div', {
    staticClass: "group_image"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/image003.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_vm._v("This scheme has the advantage of illustrating that the Age to Come moves on a higher level than this age, and that the time between the resurrection and the parousia is a time of the overlapping of the two ages. The church lives "), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_vm._v("“between the times”; the old age goes on, but the powers of the new age have irrupted into the old age.")])]), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("We would suggest a further modification better to illustrate the New Testament time line:")]), _vm._v(" "), _c('div', {
    staticClass: "group_image"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/image004.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_vm._v("There is a twofold dualism in the New Testament: God’s will is done in heaven; his Kingdom brings it to earth. In the Age to Come, heaven descends to earth and lifts historical existence to a new level of redeemed life (Rev. 21:2-3). This is hinted at, although not elaborated on, in the Gospels. Those who “attain to that age and to the resurrection from the dead neither marry nor are given in marriage, for they cannot die any more, because they are equal to angels and are sons of God, being sons of the resurrection” (Lk. 20:35-36). Here is a truly inconceivable order of existence. There are no human analogies to describe existence without the physiological and sociological bonds of sex and family. But this is the will of God: to conquer evil and to bring his people finally into the blessed immortality of the eternal life of the Age to Come.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This diagram also suggests that God’s Kingdom was active in the Old Testament. In such events as the Exodus and the captivity in Babylon, God was acting in his kingly power to deliver or judge his people. However, in some real sense God’s Kingdom "), _c('i', [_vm._v("came")]), _vm._v(" into history in the person and mission of Jesus.")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('img', {
    attrs: {
      "alt": "line",
      "src": "images/line1.jpg"
    }
  })])]), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "id": "page_67"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn1",
      "id": "rfn1"
    }
  }, [_vm._v("1")]), _vm._v(". See T. W. Manson, "), _c('i', [_vm._v("The Teaching of Jesus")]), _vm._v(" (1935), 135.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn2",
      "id": "rfn2"
    }
  }, [_vm._v("2")]), _vm._v(". Eng. ed. "), _c('i', [_vm._v("Jesus’ Proclamation of the Kingdom of God")]), _vm._v(" (1971).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn3",
      "id": "rfn3"
    }
  }, [_vm._v("3")]), _vm._v(". See below.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn4",
      "id": "rfn4"
    }
  }, [_vm._v("4")]), _vm._v(". C. H. Dodd, "), _c('i', [_vm._v("The Founder of Christianity")]), _vm._v(" (1970), 115.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn5",
      "id": "rfn5"
    }
  }, [_vm._v("5")]), _vm._v(". C. T. Craig, "), _c('i', [_vm._v("The Beginning of Christianity")]), _vm._v(" (1943), 87.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn6",
      "id": "rfn6"
    }
  }, [_vm._v("6")]), _vm._v(". M. Dibelius, "), _c('i', [_vm._v("Jesus")]), _vm._v(" (1949), 68-88.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn7",
      "id": "rfn7"
    }
  }, [_vm._v("7")]), _vm._v(". “Sich realisierende Eschatologie.” See J. Jeremias, "), _c('i', [_vm._v("The Parables of Jesus")]), _vm._v(" (1963; rev. ed.), 21, 230.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn8",
      "id": "rfn8"
    }
  }, [_vm._v("8")]), _vm._v(". J. Jeremias, "), _c('i', [_vm._v("NT Theology")]), _vm._v(" (1971), 47, 82.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn9",
      "id": "rfn9"
    }
  }, [_vm._v("9")]), _vm._v(". "), _c('i', [_vm._v("Ibid.")]), _vm._v(", 286.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn10",
      "id": "rfn10"
    }
  }, [_vm._v("10")]), _vm._v(". "), _c('i', [_vm._v("Ibid.")]), _vm._v(", 310.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn11",
      "id": "rfn11"
    }
  }, [_vm._v("11")]), _vm._v(". "), _c('i', [_vm._v("Ibid.")]), _vm._v(", 286.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn12",
      "id": "rfn12"
    }
  }, [_vm._v("12")]), _vm._v(". Recent literature: J. D. Pentecost, "), _c('i', [_vm._v("Things to Come")]), _vm._v(" (1958); A. J. McClain, "), _c('i', [_vm._v("The Greatness of the Kingdom")]), _vm._v(" (1959); J. Walvoord, "), _c('i', [_vm._v("The Millennial Kingdom")]), _vm._v(" (1959); C. C. Ryrie, "), _c('i', [_vm._v("Dispensationalism Today")]), _vm._v(" (1965); "), _c('i', [_vm._v("The New Scofield Reference Bible")]), _vm._v(" (1967). A thorough criticism of this view will be found in the present author’s "), _c('i', [_vm._v("Crucial Questions about the Kingdom of God")]), _vm._v(" (1952).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn13",
      "id": "rfn13"
    }
  }, [_vm._v("13")]), _vm._v(". See the studies by H. N. Ridderbos, R. Schnackenburg, and G. E. Ladd.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn14",
      "id": "rfn14"
    }
  }, [_vm._v("14")]), _vm._v(". See G. von Rad, "), _c('i', [_vm._v("TDNT")]), _vm._v(" 1:567-69. Bright’s excellent books deal almost exclusively with the Kingdom of God as a future hope.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn15",
      "id": "rfn15"
    }
  }, [_vm._v("15")]), _vm._v(". See G. E. Ladd, "), _c('i', [_vm._v("Jesus and the Kingdom")]), _vm._v(", 72-97.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn16",
      "id": "rfn16"
    }
  }, [_vm._v("16")]), _vm._v(". See the War Scroll in A. Dupont-Sommer, "), _c('i', [_vm._v("The Essene Writings from Qumran")]), _vm._v(" (1961), 164-97; H. Ringgren, "), _c('i', [_vm._v("The Faith of Qumran")]), _vm._v(" (1963), 152ff.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn17",
      "id": "rfn17"
    }
  }, [_vm._v("17")]), _vm._v(". G. Dalman, "), _c('i', [_vm._v("The Words of Jesus")]), _vm._v(" (1909), 91-101.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn18",
      "id": "rfn18"
    }
  }, [_vm._v("18")]), _vm._v(". "), _c('i', [_vm._v("Loc. cit.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn19",
      "id": "rfn19"
    }
  }, [_vm._v("19")]), _vm._v(". "), _c('i', [_vm._v("Ibid.")]), _vm._v(", 99. Probably late first century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("B.C.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn20",
      "id": "rfn20"
    }
  }, [_vm._v("20")]), _vm._v(". See K. G. Kuhn, “Basileus,” "), _c('i', [_vm._v("TDNT")]), _vm._v(" 1:572.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn21",
      "id": "rfn21"
    }
  }, [_vm._v("21")]), _vm._v(". For this twofold emphasis, see J. Jeremias, "), _c('i', [_vm._v("NT Theology")]), _vm._v(" (1971), 99.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn22",
      "id": "rfn22"
    }
  }, [_vm._v("22")]), _vm._v(". E. Schürer, "), _c('i', [_vm._v("The History of the Jewish People in the Age of Jesus Christ (175 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("B.C.")]), _vm._v("-"), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.D.")]), _vm._v(" 135)")]), _vm._v(", rev. ed. (1973), ed. M. Black, G. Vermes, and F. Millar, 1:534-57. For newly discovered letters from his hand, see J. T. Milik, "), _c('i', [_vm._v("Ten Years of Discovery in the Wilderness of Judaea")]), _vm._v(" (1959), 136.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn23",
      "id": "rfn23"
    }
  }, [_vm._v("23")]), _vm._v(". E. Schürer, "), _c('i', [_vm._v("The Jewish People")]), _vm._v(", 80.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn24",
      "id": "rfn24"
    }
  }, [_vm._v("24")]), _vm._v(". S. Mowinckel, "), _c('i', [_vm._v("He That Cometh")]), _vm._v(" (1956), 284f.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn25",
      "id": "rfn25"
    }
  }, [_vm._v("25")]), _vm._v(". See W. G. Kümmel, "), _c('i', [_vm._v("Promise and Fulfilment")]), _vm._v(" (1957).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn26",
      "id": "rfn26"
    }
  }, [_vm._v("26")]), _vm._v(". See G. E. Ladd, "), _c('i', [_vm._v("Jesus and the Kingdom")]), _vm._v(" (1964), 43ff.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn27",
      "id": "rfn27"
    }
  }, [_vm._v("27")]), _vm._v(". See G. Dalman, "), _c('i', [_vm._v("The Words of Jesus")]), _vm._v(", 91-101; G. F. Moore, "), _c('i', [_vm._v("Judaism")]), _vm._v(" (1927), 2:371-76.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn28",
      "id": "rfn28"
    }
  }, [_vm._v("28")]), _vm._v(". See G. E. Ladd, "), _c('i', [_vm._v("Jesus and the Kingdom")]), _vm._v(", 130. See also “The Kingdom of God — Reign or Realm?” "), _c('i', [_vm._v("JBL")]), _vm._v(" 31 (1962), 230-38.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn29",
      "id": "rfn29"
    }
  }, [_vm._v("29")]), _vm._v(". BAGD, 134.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn30",
      "id": "rfn30"
    }
  }, [_vm._v("30")]), _vm._v(". An exception is some manuscripts of Jn. 3:21.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn31",
      "id": "rfn31"
    }
  }, [_vm._v("31")]), _vm._v(". Mt. 12:28; 19:24; 21:31, 43.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn32",
      "id": "rfn32"
    }
  }, [_vm._v("32")]), _vm._v(". J. Jeremias, "), _c('i', [_vm._v("NT Theology")]), _vm._v(" (1971), 97.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn33",
      "id": "rfn33"
    }
  }, [_vm._v("33")]), _vm._v(". G. E. Ladd, "), _c('i', [_vm._v("Jesus and the Kingdom")]), _vm._v(", 126-27.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn34",
      "id": "rfn34"
    }
  }, [_vm._v("34")]), _vm._v(". J. Jeremias, "), _c('i', [_vm._v("NT Theology")]), _vm._v(", 96.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn35",
      "id": "rfn35"
    }
  }, [_vm._v("35")]), _vm._v(". It is significant that the parallel passage in Mt. 19:23-24 has both “kingdom of God” and “kingdom of the heavens,” used synonymously.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn36",
      "id": "rfn36"
    }
  }, [_vm._v("36")]), _vm._v(". C. H. Dodd, "), _c('i', [_vm._v("The Parables of the Kingdom")]), _vm._v(" (1935), 49.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn37",
      "id": "rfn37"
    }
  }, [_vm._v("37")]), _vm._v(". See G. E. Ladd, “Fulfillment without Consummation,” "), _c('i', [_vm._v("Jesus and the Kingdom")]), _vm._v(", 101-17.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn38",
      "id": "rfn38"
    }
  }, [_vm._v("38")]), _vm._v(". The parallel verse, Lk. 11:20, reads “finger of God.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn39",
      "id": "rfn39"
    }
  }, [_vm._v("39")]), _vm._v(". See Rom. 9:31; 2 Cor. 10:14; Phil. 3:16. See G. E. Ladd, "), _c('i', [_vm._v("Jesus and the Kingdom")]), _vm._v(", 137ff.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn40",
      "id": "rfn40"
    }
  }, [_vm._v("40")]), _vm._v(". G. E. Ladd, "), _c('i', [_vm._v("Jesus and the Kingdom")]), _vm._v(", 145-57.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn41",
      "id": "rfn41"
    }
  }, [_vm._v("41")]), _vm._v(". E. Best, "), _c('i', [_vm._v("The Temptation and the Passion")]), _vm._v(" (1965), 12.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn42",
      "id": "rfn42"
    }
  }, [_vm._v("42")]), _vm._v(". O. Cullmann, "), _c('i', [_vm._v("Christ and Time")]), _vm._v(" (1964), 198.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn43",
      "id": "rfn43"
    }
  }, [_vm._v("43")]), _vm._v(". "), _c('i', [_vm._v("Ibid.")]), _vm._v(", 84.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn44",
      "id": "rfn44"
    }
  }, [_vm._v("44")]), _vm._v(". J. Jeremias, "), _c('i', [_vm._v("NT Theology")]), _vm._v(", 95.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn45",
      "id": "rfn45"
    }
  }, [_vm._v("45")]), _vm._v(". E. Best, "), _c('i', [_vm._v("The Temptation and the Passion")]), _vm._v(", 15.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn46",
      "id": "rfn46"
    }
  }, [_vm._v("46")]), _vm._v(". R. Leivestad, "), _c('i', [_vm._v("Christ the Conqueror")]), _vm._v(" (1954), 47.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn47",
      "id": "rfn47"
    }
  }, [_vm._v("47")]), _vm._v(". A. Fridrichsen, "), _c('i', [_vm._v("Theology")]), _vm._v(", 22 (1931), 127.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn48",
      "id": "rfn48"
    }
  }, [_vm._v("48")]), _vm._v(". J. Jeremias, "), _c('i', [_vm._v("NT Theology")]), _vm._v(", 85.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn49",
      "id": "rfn49"
    }
  }, [_vm._v("49")]), _vm._v(". See G. E. Ladd, "), _c('i', [_vm._v("Jesus and the Kingdom")]), _vm._v(", 150-54.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn50",
      "id": "rfn50"
    }
  }, [_vm._v("50")]), _vm._v(". L. H. Marshall takes this idea as “the point of departure for understanding Jesus’ message of the Kingdom.” "), _c('i', [_vm._v("The Challenge of NT Ethics")]), _vm._v(" (1947), 26ff.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn51",
      "id": "rfn51"
    }
  }, [_vm._v("51")]), _vm._v(". For further discussion, see G. E. Ladd, "), _c('i', [_vm._v("Jesus and the Kingdom")]), _vm._v(", 224.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn52",
      "id": "rfn52"
    }
  }, [_vm._v("52")]), _vm._v(". O. Cullmann, "), _c('i', [_vm._v("Christ and Time")]), _vm._v(", 82.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn53",
      "id": "rfn53"
    }
  }, [_vm._v("53")]), _vm._v(". C. K. Barrett in "), _c('i', [_vm._v("ET")]), _vm._v(" 65 (1953-54), 372.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn54",
      "id": "rfn54"
    }
  }, [_vm._v("54")]), _vm._v(". G. Vos, "), _c('i', [_vm._v("The Pauline Eschatology")]), _vm._v(" (1952), 38.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a5162ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter004.vue
// module id = 87
// module chunks = 0